import React, { Component } from 'react';
import './TrackOrder.scss';
import SimpleHeader from '../../components/Header/simpleHeader';
import Footer from '../../components/Footer/Footer';
import image from '../../Assets/images/Checkout/trackOrder.svg';
import Stepper from './Stepper';
import Button from '../../components/Button/Button';
// import image1 from '../../Assets/images/HomePage/truckIcon1.jpg';
import { trackOrder } from '../../global/texts/trackOrder';
import { globalVal } from '../../global/globalvalues';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TextField from '../../components/Textfield/TextField';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Action from '../../store/TrackOrder/actions';
import * as Action1 from '../../store/Checkout/actions';
import * as Action2 from '../../store/HomePage/actions';
import _ from 'lodash';
import { validateEmail } from '../../global/commonFunctions/ValidateEmail';
import piggyImage from '../../Assets/images/commonImages/piggy.webp';
// import { pushTrackingEventsToGAAndFB } from '../../global/commonFunctions/GaAndFb';
import TagManager from 'react-gtm-module';
import { store } from 'react-notifications-component';
import * as PostActivationAction from '../../store/PostActivation/actions';
import { differenceInMilliseconds } from 'date-fns';
import BackButton from '../../Assets/images/commonImages/backButton.svg';
import GenericError from '../../components/GenericError/GenericError';
import { CircularProgress } from '@material-ui/core';
import { returnName } from '../../global/commonFunctions/getUserName';
import { OrderStatuses } from '../../enums';

//For Type script support
declare global {
    interface Window {
        dataLayer: Record<string, any>[];
    }
}

type initialProps = {
    history: any;
    TrackOrderActions: any;
    TrackOrderState: any;
    CheckoutActions: any;
    CheckoutState: any;
    homeAction: any;
    PostActivationState: any;
    PostActivationAction: any;
};
type initialState = {
    user: any;
    // primaryCustomer: any;
    isReachCredit: boolean;
    // planData: any;
    customerData: any;
    trackOrderData: any;
    formData: any;
    maxCount: number;
    reachCredit: number;
    isShowAll: boolean;
    mappingCount: number;
    errorMain: string;
    referalData: any;
    isTextFieldsShow: boolean;
    backBtn: boolean;
    orderId: any;
    secondaryCustomerID: any;
    currentUser: any;
    woNumber: any;
    // irSrc: any;
    isCustomerDisabled: boolean;
    isLoader: boolean;
    isFraudAcc: boolean;
};
const tagManagerArgs = {
    gtmId: `${process.env.REACT_APP_PAYMENT_ADDRESS}`,
};
TagManager.initialize(tagManagerArgs);

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
export class TrackOrder extends Component<initialProps, initialState> {
    state: initialState = {
        user: null,
        // primaryCustomer: null,
        isReachCredit: false,
        // planData: [],
        customerData: [],
        trackOrderData: [],
        formData: {},
        maxCount: 0,
        reachCredit: 0,
        isShowAll: false,
        mappingCount: 3,
        errorMain: '',
        referalData: [],
        isTextFieldsShow: false,
        backBtn: true,
        orderId: 0,
        secondaryCustomerID: '',
        currentUser: null,
        woNumber: '',
        // irSrc: '',
        isCustomerDisabled: false,
        isLoader: true,
        isFraudAcc: false,
    };

    componentDidMount() {
        window.scroll(0, 0);
        store.removeNotification('trackOrderMessage');
        let user1: any = localStorage.getItem('currentuser');
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        if(customerDetail?.category === 'FRAUD') {
            this.setState({
                isFraudAcc: true
            })
        }
        let secondaryUserDetails: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUserDetails = JSON.parse(secondaryUserDetails);
        let woNumberMap: any = localStorage.getItem('woNumberMap');
        woNumberMap = JSON.parse(woNumberMap);
        if (secondaryUserDetails) {
            this.setState({
                currentUser: secondaryUserDetails,
                woNumber: woNumberMap && woNumberMap[secondaryUserDetails?.id],
            });
        } else {
            this.setState({ currentUser: customerDetail, woNumber: woNumberMap && woNumberMap[customerDetail?.id] });
        }
        this.props.PostActivationAction.customerGroup({ groupId: customerDetail && customerDetail.groupId });
        this.props.TrackOrderActions.trackOrderGet({
            customerId: customerDetail?.id
        })
        const orders = [];
        const { shipmentInfo } = customerDetail;
        for (const orderId in shipmentInfo) {
            if (shipmentInfo?.hasOwnProperty(orderId)) {
                const date = shipmentInfo[orderId];
                orders.push({ orderId, date });
            }
        }
        const currentOrderId = orders?.sort((a, b) => differenceInMilliseconds(b.date, a.date))[0]?.orderId;

        if (this.props.history?.location?.orderId) {
            this.setState({
                orderId: this.props.history.location.orderId,
            });
        } else {
            this.setState({
                orderId: currentOrderId,
            });
        }

        this.setState({
            secondaryCustomerID: this.props?.history?.location?.secondaryCustomerID?.[0],
            // primaryCustomer: customerDetail,
        });
        if (this.props.history && this.props.history.location && this.props.history.location.state === 'isTrack') {
            this.setState({ backBtn: true });
        }

        user1 = JSON.parse(user1);
        if (user1) {
            this.setState({
                user: user1,
            });
        }
        let email: string = customerDetail && customerDetail.emailId ? customerDetail.emailId : '';
        email &&
            this.props.CheckoutActions.GetCustomer({
                username: encodeURIComponent(email),
            });
        email &&
            this.props.TrackOrderActions.referalGet({
                emailId: encodeURIComponent(email),
            });
        // pushTrackingEventsToGAAndFB({
        //     category: 'Track Order',
        //     actionType: 'Track Order Clicked',
        // });
        let moneySaving: any = localStorage.getItem('moneySavingPro');
        if (moneySaving) {
            let msp = JSON.parse(moneySaving);
            let moneySavingIframe = document.createElement('iframe');
            moneySavingIframe.src = globalVal.mspURL + msp.utm_content;
            moneySavingIframe.style.visibility = 'hidden';

            document.body.appendChild(moneySavingIframe);
        }

        if (!_.isEmpty(localStorage.getItem('reachPurhcaseUserCoupon'))) {
            let payloadURL = globalVal.REACH_INVITE_REFERRALS_URL + '?' + this.reach_tracking_pixel();
            this.submitInviteReferral(payloadURL);
            localStorage.removeItem('reachPurhcaseUserCoupon');
        } else if (!_.isEmpty(localStorage.getItem('reachPurhcaseReferralUserCoupon'))) {
            let payloadURL = globalVal.REACH_INVITE_REFERRALS_URL + '?' + this.reach_tracking_pixel();
            this.submitInviteReferral(payloadURL);
            localStorage.removeItem('reachPurhcaseReferralUserCoupon');
        }
    }

    submitInviteReferral = (payloadURL: any) => {
        // console.log('ir - ', payloadURL);
        fetch(payloadURL)
            .then(response => response.json())
            .then()
            .catch(error => {
                console.error('IR Error:', error);
            });
    };

    createUUID = () => {
        var s: any = [];
        var hexDigits = '0123456789abcdef';
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';

        var uuid = s.join('');
        return uuid;
    };

    // invite referral coupon
    reach_tracking_pixel = () => {
        let user: any = localStorage.getItem('currentuser');
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);
        let req: any = {
            bid_e: globalVal.REACH_INVITE_REFERRALS_BID_E,
            bid: globalVal.REACH_INVITE_REFERRALS_BID,
            t: globalVal.REACH_INVITE_REFERRALS_T,
            event: globalVal.REACH_INVITE_REFERRALS_EVENT,
            email: user.email ? user.email : currentdetails.emailId,
            orderID: this.createUUID(),
            campaignid: globalVal.REACH_INVITE_REFERRALS_CAMPAIGNID,
            fname: user.displayName ? user.displayName : currentdetails?.firstName,
        };

        let reachPurhcaseUserCoupon = localStorage.getItem('reachPurhcaseUserCoupon');
        let reachPurhcaseReferralUserCoupon = localStorage.getItem('reachPurhcaseReferralUserCoupon');
        if (reachPurhcaseUserCoupon) {
            req.couponCode = JSON.parse(reachPurhcaseUserCoupon).couponCode;
        } else if (reachPurhcaseReferralUserCoupon) {
            req.couponCode = JSON.parse(reachPurhcaseReferralUserCoupon).couponCode;
        } else {
            req.couponCode = '';
        }

        let queryParam = '';
        _.each(req, function(value: any, key: any) {
            queryParam += key + '=' + value + '&';
        });
        queryParam = queryParam.slice(0, -1);
        return queryParam;
    };

    componentDidUpdate(
        prevProps: initialProps,
        // , prevState: initialState
    ) {
        const prev = prevProps && prevProps.CheckoutState;
        const cur = this.props && this.props.CheckoutState;
        const prev1 = prevProps && prevProps.TrackOrderState;
        const cur1 = this.props && this.props.TrackOrderState;
        // get customer data
        if (prev.getCustomer !== cur.getCustomer && cur.getCustomer && cur.getCustomer.status === 'SUCCESS') {
            this.setState({ isLoader: false });
            if (cur.getCustomer.data.status === 7) {
                this.setState({ isCustomerDisabled: true });
            }
            if (
                cur.getCustomer.data &&
                cur.getCustomer.data.shipmentInfo &&
                cur.getCustomer.data.reachPlanId &&
                Object.keys(cur.getCustomer.data.shipmentInfo)[
                    Object.keys(cur.getCustomer.data.shipmentInfo).length - 1
                ]
            ) {
                this.setState({
                    customerData: cur.getCustomer.data,
                });
                // this.props.TrackOrderActions.trackOrder({
                //     poll: true,
                //     orderId: this.state.orderId && this.state.orderId,
                //     // orderId: this.state.orderId
                //     //     ? this.state.orderId
                //     //     : Object.keys(cur.getCustomer.data.shipmentInfo)[
                //     //     Object.keys(cur.getCustomer.data.shipmentInfo).length - 1
                //     //     ],
                // });
                this.props.TrackOrderActions.reachPlan({
                    plan: cur.getCustomer.data.reachPlanId,
                });
            }
            let paymentStatus = localStorage.getItem('userPaymnetStatus');
            if (paymentStatus && JSON.parse(paymentStatus) === 'yes') {
                // pushTrackingEventsToGAAndFB({
                //     category: 'PurchaseFlow',
                //     actionType: 'PaymentSuccess',
                //     label: cur.getCustomer.data && cur.getCustomer.data.extraLines,
                // });

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'PaymentSuccess',
                });

                localStorage.removeItem('userPaymnetStatus');
                if (cur.getCustomer.data && cur.getCustomer.data.emailId) {
                    this.props.homeAction.getInTouch({
                        data: {
                            emailId: cur.getCustomer.data && cur.getCustomer.data.emailId,
                            hubspotMap: {
                                email: cur.getCustomer.data && cur.getCustomer.data.emailId,
                                is_test: globalVal.hubspot_is_test,
                                is_qa: globalVal.hubspot_is_qa,
                                website_journey_score: 8,
                                is_auto_pay: true,
                                website_purchase_payment_failed_reason: '',
                                website_number_of_lines: cur.getCustomer.data && cur.getCustomer.data.extraLines,
                            },
                        },
                    });
                }
            }
        }
        if (
            prev1.TrackOrderGet !== cur1.TrackOrderGet && 
            cur1.TrackOrderGet && 
            cur1.TrackOrderGet.status === 'SUCCESS'
        ) {
            let data: any;
            cur1.TrackOrderGet.data.map((el:any) => {
                el.woNumberMap &&
                    Object.keys(el.woNumberMap).map((id:any) => {
                        if(id === this.state.currentUser.id) {
                            if(data && data.orderDate && data.orderDate > el.orderDate) {
                                this.setState({
                                    trackOrderData: data
                                })
                            } else {
                                data = el;
                                this.setState({
                                    trackOrderData: el
                                })
                            }
                        }
                    })
            })
        }
        // get track order data
        // if (prev1.TrackOrder !== cur1.TrackOrder && cur1.TrackOrder && cur1.TrackOrder.status === 'SUCCESS') {
        //     this.setState({
        //         trackOrderData: cur1.TrackOrder.data,
        //     });
        // }
        // get reach plan data
        // if (
        //     prev1.ReachPlan !== cur1.ReachPlan &&
        //     cur1.ReachPlan &&
        //     cur1.ReachPlan.status === 'SUCCESS' &&
        //     cur1.ReachPlan.data
        // ) {
        //     this.setState({
        //         planData: cur1.ReachPlan.data,
        //     });
        // }
        //get referee list
        if (
            prev1.ReferalGet !== cur1.ReferalGet &&
            cur1.ReferalGet &&
            cur1.ReferalGet.status === 'SUCCESS' &&
            cur1.ReferalGet.data
            // &&
            // cur1.ReferalGet.data.refereeList.length > 0
        ) {
            this.setState({
                maxCount: cur1.ReferalGet.data.config.max_number_of_referees - cur1.ReferalGet.data.refereeList.length,
                reachCredit: cur1.ReferalGet.data.config.post_purchase_referrer_credit,
                referalData: cur1.ReferalGet.data.refereeList,
            });
            // if (cur1.ReferalGet.data.refereeList.length !== 0) {
            if (cur1.ReferalGet.data.config.max_number_of_referees - cur1.ReferalGet.data.refereeList.length < 3) {
                this.setState({
                    mappingCount:
                        cur1.ReferalGet.data.config.max_number_of_referees - cur1.ReferalGet.data.refereeList.length,
                });
            }
        }
        //post referee list
        if (prev1.Referal !== cur1.Referal && cur1.Referal && cur1.Referal.status === 'SUCCESS' && cur1.Referal.data) {
            this.setState({
                formData: {},
                isTextFieldsShow: false,
                mappingCount: 3,
            });

            let user1: any = localStorage.getItem('currentuser');
            user1 = JSON.parse(user1);
            let email: string = user1 && user1.email ? user1.email : '';
            email &&
                this.props.TrackOrderActions.referalGet({
                    emailId: email,
                });
        }

        if (prev1.errorReferal !== cur1.errorReferal && cur1.errorReferal && cur1.errorReferal.status === 'FAILURE') {
            this.setState({
                errorMain: 'You have previously submitted this email. Please enter a unique email each time.',
            });
        }
    }
    getSteps = () => {
        const { trackOrderData, customerData } = this.state;
        if (trackOrderData.cId && customerData.id) {
            let time = new Date(trackOrderData.orderDate);
            // time.getHours();
            // let ampm:any = time.getHours() >= 12 ? "pm" : "am";
            let time1 = time.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit' });
            // time1 = time1 + ampm;
            time1 = time1.replace(/\s/g, '').toLowerCase();
            let labeledTime: any = trackOrderData.labelledOn ? new Date(trackOrderData.labelledOn) : '';
            let labeled1: any = labeledTime
                ? labeledTime.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                : '';

            let dateDelivery: any = trackOrderData.deliveredOn
                ? new Date(trackOrderData.deliveredOn)
                : trackOrderData.estimatedDeliveryDate
                ? new Date(trackOrderData.estimatedDeliveryDate)
                : '';
            // let label:any;
            // if(trackOrderData.deliveredOn) {
            //     label = 'Delivered'
            // } else {
            //     label = 'Delivery scheduled'
            // }
            let dateDelivery1: any = dateDelivery
                ? dateDelivery.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                : '';

            dateDelivery1 = dateDelivery1.replace(/\s/g, '').toLowerCase();

            let shippedTime: any = trackOrderData.shippedOn ? new Date(trackOrderData.shippedOn) : '';
            let shippedTime1: any = shippedTime
                ? shippedTime.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                : '';
            return [
                {
                    label: 'Order received',
                    text: `${time1} `,
                    time: time1,
                    date: `${time.getDate()} ${months[time.getMonth()]}, ${time.getFullYear()} `,
                    // simcards: customerData.extraLines + 1,
                },
                {
                    label: 'Processing',
                    text:
                        labeledTime && labeled1
                            ? `${trackOrder.inProgressText}`
                            : `${trackOrder.inProgressText}`,
                    //time: labeled1,
                    //date: `${labeledTime.getDate()} ${months[labeledTime.getMonth()]}, ${labeledTime.getFullYear()} `,
                },
                {
                    label: 'Order shipped',
                    text:
                        shippedTime && shippedTime1
                            ? `${trackOrder.orderShippedText}${'\n'} ${shippedTime1}${'\n'} ${shippedTime.getDate()} ${
                                  months[shippedTime.getMonth()]
                              }, ${shippedTime.getFullYear()}`
                            : `${trackOrder.orderShippedText}`,
                    //time: shippedTime1,
                    //date: `${shippedTime.getDate()} ${months[shippedTime.getMonth()]}, ${shippedTime1.getFullYear()} `,
                },
                {
                    label: trackOrderData.deliveredOn ? 'Delivered' : 'Delivery scheduled',
                    text: trackOrderData.deliveredOn ? `${dateDelivery1}` : `Arriving`,
                    time: dateDelivery1,
                    date: `${dateDelivery.getDate()} ${months[dateDelivery.getMonth()]}, ${dateDelivery.getFullYear()} `,
                },
            ];
        } else {
            return [
                { label: 'Order received' },
                {
                    label: 'Processing',
                    text: `${trackOrder.inProgressText}`,
                },
                {
                    label: 'Order shipped',
                    text: `${trackOrder.orderShippedText}`,
                },
                {
                    label: 'Delivery scheduled',
                    text: `Arriving`,
                },
            ];
        }
    };
    activateHandler = () => {
        const secondaryCustomer =
            this.props.PostActivationState &&
            this.props.PostActivationState.group &&
            this.props.PostActivationState.group.data &&
            this.props.PostActivationState.group.data.length > 0 &&
            this.props.PostActivationState.group.data.find(
                (item: { id: any }) => item.id === this.props?.history?.location?.secondaryCustomerID,
            );
        if (this.props?.history?.location && this.props?.history?.location?.isSecondary) {
            localStorage.setItem(
                'secondaryCustomerDetail',
                JSON.stringify(secondaryCustomer ? secondaryCustomer : this.state.secondaryCustomerID),
            );
        }
        this.props.history.push({
            pathname: '/activation',
            secondaryCustomerID: this.props?.history?.location?.secondaryCustomerID,
            state: {
                redirectOnClick: true,
            },
        });
    };
    reachCreditHandler = async () => {
        await this.setState({
            isReachCredit: !this.state.isReachCredit,
            formData: {},
            errorMain: '',
        });
        window.scroll(0, 0);
        if (this.state.isReachCredit) {
            // pushTrackingEventsToGAAndFB({
            //     category: 'Track Order',
            //     actionType: 'Refer Friend',
            // });
        }
    };
    onChangeHandler = async (e: any, name: string) => {
        const { formData } = this.state;

        await this.setState({
            formData: _.set({ ...formData }, name, e.target.value),
        });
        if (name === 'name2' || name === 'email2') {
            await this.setState({
                isShowAll: true,
                mappingCount: this.state.maxCount,
            });
        }
    };
    submitHandler = async () => {
        let data: any = [];
        const { formData, customerData, mappingCount } = this.state;
        let email = customerData && customerData.emailId;
        let isError: boolean = false;
        let isNameError: boolean = false;
        let isDuplicateError: boolean = false;
        for (let index = 0; index < mappingCount; index++) {
            if (formData[`email${index}`] && formData[`name${index}`] && validateEmail(formData[`email${index}`])) {
                data.push({
                    referrerEmailId: email,
                    refereeEmailId: formData[`email${index}`],
                    refereeName: formData[`name${index}`],
                });
            } else if (formData[`email${index}`] && !validateEmail(formData[`email${index}`])) {
                isError = true;
            } else if (formData[`name${index}`]) {
                isNameError = true;
            }
        }
        var valueArr = data.map(function(item: any) {
            return item.refereeEmailId;
        });
        if (new Set(valueArr).size !== valueArr.length) {
            isDuplicateError = true;
        }

        this.setState({
            errorMain: '',
        });

        if (data.length > 0 && !isError && !isNameError && !isDuplicateError) {
            await this.setState({
                errorMain: '',
            });
            this.props.TrackOrderActions.referal({ data: data });
        } else if (isError) {
            await this.setState({
                errorMain: 'Enter Valid Email',
            });
        } else if (isDuplicateError) {
            await this.setState({
                errorMain: 'Please enter a unique email each time.',
            });
        } else {
            await this.setState({
                errorMain: 'Enter at least 1 name and email to earn credits.',
            });
        }
    };
    inviteAndEarnCredit = () => {
        this.setState({
            isTextFieldsShow: true,
        });
        // pushTrackingEventsToGAAndFB({
        //     category: 'Track Order',
        //     actionType: 'Invite Friend',
        //     label: 'Invite Friends And Earn Reach Credit',
        // });
    };
    convertToOrdinal(number: any) {
        const ordinalWords = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'];
        const value = parseInt(number);
        return ordinalWords[value];
    }
    render() {
        const {
            isReachCredit,
            // planData,
            customerData,
            trackOrderData,
            reachCredit,
            formData,
            errorMain,
            mappingCount,
            referalData,
            isTextFieldsShow,
            orderId,
            currentUser,
            woNumber,
            // primaryCustomer,
            // irSrc,
            isCustomerDisabled,
            isLoader,
        } = this.state;
        let secondaryUserDetails: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUserDetails = JSON.parse(secondaryUserDetails);
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);

        let disableActivate: boolean = false;
        if (secondaryUserDetails && customerDetail?.status !== 2 && customerDetail?.status !== 3 || this.state.isFraudAcc) {
            disableActivate = true;
        }
        // let currentPlan: any = localStorage.getItem('currentPlan');
        // currentPlan = JSON.parse(currentPlan);
        // let lineNumber: any = localStorage.getItem('lineNumber');
        // lineNumber = JSON.parse(lineNumber);
        let activeStep: number = 0;
        if (trackOrderData && trackOrderData.cId) {
            activeStep =
                trackOrderData.orderStatus === OrderStatuses.ORDERED
                    ? 0
                    : trackOrderData.orderStatus === OrderStatuses.LABELLED
                    ? 1
                    : trackOrderData.orderStatus === OrderStatuses.SHIPPED
                    ? 2
                    : trackOrderData.orderStatus === OrderStatuses.DELIVERED
                    ? 3
                    : 0;
        }
        const items = [];
        for (let index = 0; index < mappingCount; index++) {
            items.push(
                <div className="rowTextField">
                    <div className="numbers">{index + 1}</div>
                    <div className="individualTextfield">
                        <TextField
                            value={formData[`name${index}`]}
                            label="Name"
                            onChange={(e: any) => this.onChangeHandler(e, `name${index}`)}
                        />
                    </div>
                    <div className="individualTextfield mobileTextfield">
                        <TextField
                            value={formData[`email${index}`]}
                            label="Email"
                            onChange={(e: any) => this.onChangeHandler(e, `email${index}`)}
                            error={formData[`email${index}`] && !validateEmail(formData[`email${index}`])}
                            // helperText={
                            //     formData[`email${index}`] && !validateEmail(formData[`email${index}`])
                            //         ? 'Enter valid email'
                            //         : ''
                            // }
                        />
                    </div>
                </div>,
            );
        }

        return (
            <div className="TrackOrderMain">
                {/* <img style={{ position: 'absolute', visibility: 'hidden' }} src={irSrc} /> */}
                <div
                    className={
                        mappingCount > 3
                            ? 'backdropcolorTrackOrder isMappingCount'
                            : isReachCredit
                            ? 'backdropcolorTrackOrder isReach'
                            : 'backdropcolorTrackOrder isReachActive'
                    }
                ></div>
                <SimpleHeader history={this.props.history} user={this.state.currentUser} isHelp={true} />
                <div className="InnerMainDiv">
                    <div className="MiddleCard">
                        {isReachCredit ? (
                            <div className="mainDivCredit">
                                <div className="headDivTrack">
                                    <ArrowBackIcon className="backArrow" onClick={this.reachCreditHandler} />
                                    <div className="Heading">
                                        Share {globalVal.short_name} with your friends and earn{' '}
                                        <span>
                                            ${reachCredit} {globalVal.short_name} credit{' '}
                                        </span>
                                        for each valid email address
                                    </div>
                                    <div></div>
                                </div>
                                {referalData.length > 0 && !isTextFieldsShow ? (
                                    <div className="otherTrackDiv">
                                        <img className="imagePiggy" src={piggyImage} alt="" />
                                        <div className="HeadingC">Congratulation!</div>
                                        <div className="spanC">
                                            You’ve earned $ {referalData.length * reachCredit} {globalVal.short_name}{' '}
                                            credit
                                        </div>
                                        {mappingCount > 0 && (
                                            <div className="InviteButton">
                                                <Button primary={true} onClick={this.inviteAndEarnCredit}>
                                                    Invite friends & earn {globalVal.short_name} credit
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div>
                                        {errorMain && <div className="errorTextMain">{errorMain}</div>}
                                        <div
                                            className="textFieldsDiv"
                                            onKeyPress={(e: any) => {
                                                if (e.key === 'Enter') {
                                                    this.submitHandler();
                                                }
                                            }}
                                        >
                                            {items}
                                        </div>
                                        <div className="submitButton">
                                            <Button primary={true} onClick={this.submitHandler}>
                                                Submit
                                            </Button>
                                        </div>
                                        <div className="skipBtn" onClick={() => this.props.history.push('/feedback')}>
                                            Skip
                                        </div>
                                        {referalData.length > 0 && (
                                            <div className="borderOutside">
                                                <div className="headingBorderOutside">Invitation sent to</div>
                                                {referalData.map((item: any, index: number) => {
                                                    return (
                                                        <span key={index} className="mainSpan">
                                                            <span className="nameDiv">{item.refereeName}</span>
                                                            <span className="emailDiv">({item.refereeEmailId}), </span>
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="lastDiv">
                                    Your feedback is very important to us,{' '}
                                    <span onClick={() => this.props.history.push('/feedback')}>
                                        share your feedback <ArrowRightIcon className="triangle" />
                                    </span>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="Heading">
                                    {this.state.backBtn && (
                                        <img
                                            src={BackButton}
                                            className="backToHome"
                                            onClick={() =>
                                                this.props.history.push({
                                                    pathname: '/post-activation-home',
                                                })
                                            }
                                        />
                                    )}
                                    Track Order
                                </div>
                                <div className="bottomLine"></div>
                                {isLoader ? (
                                    <div className="loader-check text-center">
                                        <CircularProgress />
                                    </div>
                                ) : isCustomerDisabled ? (
                                    <div className="trackOrderGenericErr">
                                        <GenericError isDisabled={true} />
                                    </div>
                                ) : (
                                    <div className="InnerContent">
                                        <img className="imageUpper" alt="img" src={image} />
                                        {/* {planData && planData.name && customerData && customerData.id ? ( */}
                                        {customerData && customerData.id ? (
                                            <div className="PlanName">
                                                <span className='username'>
                                                {currentUser?.firstName || currentUser?.lastName ? (
                                                    currentUser?.firstName && !currentUser?.lastName ? (
                                                        `${returnName(currentUser, "firstName")}`
                                                    ) : (
                                                        !currentUser?.firstName && currentUser?.lastName ? (
                                                        `${returnName(currentUser, "lastName")}`
                                                        ) : (
                                                        `${returnName(currentUser, "firstName")} ${returnName(currentUser,"lastName")}`
                                                        )
                                                    )
                                                    ) : (
                                                    this.convertToOrdinal((currentUser?.peerAccountRef?.split('|')[2] - 1))?.toUpperCase() + ' LINE'
                                                )}
                                                </span>
                                                {'-'} {currentUser?.reachPlanDisplayName}
                                            </div>
                                        ) : null}

                                        {orderId ? (
                                            <div className="orderNumber">
                                                Order no. {woNumber ? woNumber : trackOrderData?.woNumber}
                                            </div>
                                        ) : (
                                            <div className="orderNumber">
                                                Order no. {woNumber ? woNumber : trackOrderData?.woNumber}
                                                {/* {customerData &&
                                                    customerData.shipmentInfo &&
                                                    Object.keys(customerData.shipmentInfo)[
                                                    Object.keys(customerData.shipmentInfo).length - 1
                                                    ]} */}
                                            </div>
                                        )}

                                        <div>
                                            <Stepper activeStep={activeStep} getSteps={this.getSteps} />
                                            {/* {!secondaryUserDetails?.isSecondaryUser ? ( */}
                                            <>
                                                <div className="activateButton">
                                                    <Button
                                                        primary={true}
                                                        disabled={(activeStep === 3 && !disableActivate) ? false : true}
                                                        onClick={this.activateHandler}
                                                    >
                                                        Get Ready to Activate
                                                    </Button>
                                                </div>
                                                {activeStep !== 3 && (
                                                    <>
                                                        {' '}
                                                        <div className="line"></div>
                                                        <div className="welcomeKit">
                                                            <div className="text">
                                                                Received your Welcome Kit already?
                                                            </div>
                                                            <div
                                                                className="link"
                                                                style={{
                                                                    cursor: `${disableActivate ? 'auto' : 'pointer'}`,
                                                                    opacity: `${disableActivate ? '0.5' : '1'}`,
                                                                }}
                                                                onClick={
                                                                    disableActivate ? () => null : this.activateHandler
                                                                }
                                                            >
                                                                Activate now
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                            {/* ) : (
                                                <div className="contentCenter">
                                                        <div className="welcomeKitNew">
                                                            <div className="text">Received your Welcome Kit already?</div>
                                                            <div className="link" onClick={this.activateHandler}>
                                                                Activate now
                                                            </div>
                                                        </div>
                                                </div>
                                            )} */}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <Footer isFixed={true} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        TrackOrderActions: bindActionCreators(Action, dispatch),
        CheckoutActions: bindActionCreators(Action1, dispatch),
        homeAction: bindActionCreators(Action2, dispatch),
        PostActivationAction: bindActionCreators(PostActivationAction, dispatch),
    };
}

const mapStateToProps = (state: any) => ({
    TrackOrderState: state.trackOrder,
    CheckoutState: state.checkout,
    PostActivationState: state.postActivation,
});

export default connect(mapStateToProps, mapDispatchToProps)(TrackOrder);
